@if (benefitGroup) {
  <div class="mat-typography mat-body">
    <!-- PLAN HEADERS -->
    @if (benefitGroup.plans.length > 1) {
      <table class="plan-name-holder">
        <tr>
          <td class="benefit-name-column"></td>
          @for (planName of sortedPlanNames; track planName) {
            <td class="plan-name">{{planName.name}}</td>
          }
        </tr>
      </table>
    }
    <table>
      <!-- Row:BENEFIT-->
      @for (benefit of benefitGroup.benefits; track trackByIndex(benefitIndex, benefit); let benefitIndex = $index) {
        <tr class="benefit-first-row">
          <!-- BENEFIT_NAME-->
          <td class="benefit-name-column">
            <h3>{{ benefit.id }}</h3>
          </td>
          <!-- LIMITS -->
          <ng-container>
            <!-- UNIQUE -->
            @if (getLimitColSpan(benefit.id) === '1') {
              @for (planObj of benefitGroup.plans; track trackByIndex(planIndex, planObj); let planIndex = $index) {
                <td class="limit-td" [ngClass]="{ 'exists': doesBenefitLimitExistForPlan(planObj.id, benefit.id) }"
                  [innerHTML]="benefitGroup.planBenefits[planObj.id][benefit.id].Limit">
                </td>
              }
            } @else {
              <td [attr.colSpan]="getLimitColSpan(benefit.id)" class="limit-td"
                [ngClass]="{ 'exists': doesBenefitLimitExistForPlan(benefitGroup.plans[0].id, benefit.id) }"
                [innerHTML]="benefitGroup.planBenefits[benefitGroup.plans[0].id][benefit.id].Limit">
              </td>
            }
            <!-- STRETCH -->
          </ng-container>
        </tr>
        @for (network of getNetworksToDisplay(benefit.id) | keyvalue; track trackByIndex(i, network); let i = $index) {
          <tr>
            <td class="network-td">{{network.value}}</td>
            @for (planObj of benefitGroup.plans; track trackByIndex(planIndex, planObj); let planIndex = $index) {
              <td class="benefit-value-td">
                <!-- HIGHLIGHT VALUES -->
                @if (showHighlights$ | async) {
                  <span
                    [ngClass]="{ 'highlighted-difference' : shouldHighlight.get(planObj.id).get(benefit.id).get(network.value) }"
                    [innerHTML]="getValueOrFiller(benefitGroup.planBenefits[planObj.id][benefit.id][network.value])">
                  </span>
                } @else {
                  <span [innerHTML]="getValueOrFiller(benefitGroup.planBenefits[planObj.id][benefit.id][network.value])">
                  </span>
                }
                <!-- DO NOT HIGHLIGHT VALUES -->
              </td>
            }
          </tr>
        }
      }
    </table>
  </div>
}
